import React from 'react';
import Text from '../Text/Text';
import './row.scss';

export interface RowItemTitleProps {
    children: any;
    icons?: any;
}

const RowItemTitle = ({children, icons}: RowItemTitleProps) => {
    return (
        <div className={'row__title'}>
            {/* <Text> */}
                {children}
            {/* </Text> */}
            <div className='row__title-icon'>
                {icons}
            </div>
        </div>
    )
}

export default RowItemTitle;
